export default __webpack_public_path__ + "all-models-empty-state-image.png";